export default __webpack_public_path__ + "static/media/seamless.6a44f9ce.png";